import { Controller } from "@hotwired/stimulus"

// Shows the content only while the select holds `showFor` — e.g. the own CC/BCC fields of a
// Belegart, visible for "Eigene Adressen" only. Hidden fields still submit, so values typed
// there survive switching the mode back and forth.
//
// A content target may name its own value (`data-select-reveal-show-for="…"`), so one select
// can switch between several blocks — the Standorte or Mitarbeitertypen of a Betriebsurlaub.
export default class extends Controller {
  static targets = ["select", "content"]
  static values = { showFor: String }

  connect() {
    this.toggle()
  }

  toggle() {
    const value = this.selectTarget.value
    this.contentTargets.forEach((element) => {
      const showFor = element.dataset.selectRevealShowFor ?? this.showForValue
      element.classList.toggle("hidden", value !== showFor)
    })
  }
}
